import React from "react";
import TodoList from "./TodoList";

export default function App() {
  return <TodoList />;
}
